import { FC } from 'react';
import { Button } from '@edikk-edikk/ui';
import AdvertListFilterControlsCss from '#srcCssModules/advert/list-filter/advert-list-filter-controls.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';

const FilterItemList: FC = () => {
  const { filterItemList } = useFilterContext();

  return filterItemList.map((filterItem) => (
    <Button
      key={filterItem.url}
      variant="unstyled"
      navLinkProps={{
        to: filterItem.url,
        state: { routerConfig: filterItem.routerConfig.getData() },
        end: true,
        className: AdvertListFilterControlsCss.advertListFilterControls__action,
        activeClassName: AdvertListFilterControlsCss.advertListFilterControls__action_active,
      }}
      data-url={filterItem.url}
    >
      {filterItem.getVisibleName()}
    </Button>
  ));
};

export { FilterItemList };
